"use client";

/**
 * Desktop-only booking sidebar — lazy-loads the Form chunk and only
 * mounts it once the viewport is actually ≥ lg. Saves ≈80 KB+ of JS
 * (Choose*, react-datepicker, ConvertedPrice, Redux pricing thunks)
 * from the mobile critical path.
 */
import React, { FC, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import TourFavouriteButton from "./TourFavouriteButton";

const Form = dynamic(() => import("./Form"), {
  ssr: false,
  loading: () => <div className="min-h-[400px]" aria-hidden="true" />,
});

// Favori au-dessus du formulaire, dans la partie collante : il suit la réservation.
const TourSidebar: FC<{ tourUuid?: string }> = ({ tourUuid }) => {
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <aside className="hidden lg:block">
      <div className="sticky top-24">
        {tourUuid && (
          <div className="mb-3">
            <TourFavouriteButton tourUuid={tourUuid} variant="inline" className="w-full justify-center" />
          </div>
        )}
        {isDesktop && <Form />}
      </div>
    </aside>
  );
};

export default TourSidebar;
